import React from 'react'

const CheckboxWrapper = React.forwardRef((props, ref) => (
  <label className={'pn-text-input-checkbox' + (props.error ? ' error' : '')}>
    <input type='checkbox' {...props} ref={ref} />
    <span className='checkbox-text'>{props.label}</span>
  </label>
))

export default CheckboxWrapper
